<div class="menu-bar desktop-only">
  <div class="container">
    <p-menubar
      #menubar
      [id]="'menu-bar'"
      [model]="items"
      [ariaLabel]="'Navegue pelo nosso menu e encontre nossos produtos! Menu'"
      (click)="onClickMenu($event)"
    >
    </p-menubar>
  </div>
</div>

<div class="mobile-only">
  <app-menu-mobile [categories]="categories"></app-menu-mobile>
</div>
